export default class AdsCountdown {
  constructor(tech) {
    this.tech = tech;
    this.cuePoint = null;
    this.el = null;
  }

  init() {
    const playerContainer = this.tech.el();
    const countDownEl = document.createElement("div");
    countDownEl.className = "ads-countdown hidden";
    playerContainer.appendChild(countDownEl);
    this.el = countDownEl;

    this.tech.on("timeupdate", () => {
      if (this.cuePoint === null) {
        return;
      }

      this.display();
    });
  }

  tryDisplay(adEvent) {
    if (this.shouldStart(adEvent)) this.setCuePoint(adEvent);
  }

  shouldStart(adEvent) {
    return this.isMidrollPod(adEvent) && this.isFirstAdOfPod(adEvent);
  }

  setCuePoint(adEvent) {
    this.cuePoint = this.getCuePoint(adEvent);
  }

  getCuePoint(adEvent) {
    return adEvent.getAd().getAdPodInfo().getTimeOffset();
  }

  isMidrollPod(adEvent) {
    return adEvent.getAd().getAdPodInfo().getPodIndex() > 0;
  }

  isFirstAdOfPod(adEvent) {
    return adEvent.getAd().getAdPodInfo().getAdPosition() === 1;
  }

  constructMessage() {
    return `Iklan dalam ${this.calculateCountdown()}`;
  }

  updateMessage() {
    const msg = this.constructMessage();
    this.el.innerHTML = msg;
  }

  display() {
    if (this.shouldKeepHidden()) {
      this.hide();

      if (this.shouldReset()) {
        this.cuePoint = null;
      }
      return;
    }

    this.updateMessage();
    this.show();
  }

  shouldReset() {
    return this.tech.currentTime() >= this.cuePoint;
  }

  calculateCountdown() {
    return Math.ceil(this.cuePoint - this.tech.currentTime());
  }

  shouldKeepHidden() {
    return !this.withinRange();
  }

  withinRange() {
    const countdown = this.calculateCountdown();
    return countdown > 0 && countdown <= 5;
  }

  hide() {
    this.el.classList.add("hidden");
  }

  show() {
    this.el.classList.remove("hidden");
  }
}
